<template>
  <div v-if="!loading" class="flex flex-col">
    <router-link
      v-if="hasPermission('edit_tags')"
      :to="{ name: 'tagsCreateForm' }"
      class="primary-button mx-0 mt-4"
      >Crear Etiqueta</router-link
    >

    <div class="card mt-6">
      <table class="table-auto text-sm mt-2 bg-white w-full">
        <thead class="text-left">
          <tr class="bg-primary-100">
            <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">ID</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Nombre</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Slug</th>
            <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tag in tags" :key="tag.id" class="table-row">
            <td class="table-cell">{{ tag.id }}</td>
            <td class="table-cell">{{ tag.name }}</td>
            <td class="table-cell font-mono">{{ tag.slug }}</td>
            <td class="table-cell">
              <div class="flex space-x-2">
                <router-link
                  v-if="hasPermission('edit_tags')"
                  :to="{ name: 'tagsEditForm', params: { id: tag.id } }"
                  class="secondary-button"
                  >Editar</router-link
                >
                <button
                  v-if="hasPermission('delete_tags')"
                  class="delete-button"
                  @click="confirmDelete(tag)"
                >
                  Eliminar
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="!tags.length">
            <td colspan="4" class="text-center p-4 text-content-300">
              No hay etiquetas.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>
  </div>

  <div v-else class="flex w-full h-full items-center">
    <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
  </div>
</template>

<script>
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
export default {
  name: "Tags",

  data() {
    return {
      tags: [],
      loading: false,
      loadingDelete: false,
      tagToDelete: null,
    };
  },

  mixins: [deleteMixin],

  created() {
    this.$store.commit("setStoreSelectedTab", "tags");
    this.loadTags();
  },

  methods: {
    async loadTags() {
      this.loading = true;

      try {
        this.tags = await api.tags.getAll();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    confirmDelete(tag) {
      this.tagToDelete = tag;
      this.openDeleteModal();
    },

    async deleteElement() {
      if (!this.tagToDelete) return;
      this.loadingDelete = true;

      try {
        const response = await api.tags.delete(this.tagToDelete.id);
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        this.tagToDelete = null;
        await this.loadTags();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDelete = false;
    },
  },
};
</script>
